export const getVideoDateLabel = (video) => {
  if (!video) return "";

  return video.publishDate || video.createTime || video.createDate || video.date || "";
};
